export interface RightArrowProps {
  width?: string;
  height?: string;
}

export function RightArrow({ width = '24', height = '25', ...rest }: RightArrowProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      {...rest}
    >
      <path
        d='M13.1722 12.5L8.22217 7.54999L9.63617 6.13599L16.0002 12.5L9.63617 18.864L8.22217 17.45L13.1722 12.5Z'
        fill='#1D2B39'
      />
    </svg>
  );
}
